import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ItemLabel } from "@/react/components/shared/uikit/Form/Item/ItemLabel";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface FieldWithCounterProps {
  className?: string;
  errorMessage: string;
  label: string;
  maxLength: number;
  name: string;
}

export const FieldWithCounter = ({
  name,
  maxLength,
  children,
  label,
  errorMessage,
  className,
}: PropsWithChildren<FieldWithCounterProps>) => {
  const { watch, setError, clearErrors } = useFormContext();

  const input = watch<string>(name);

  const inputCount = input?.length || 0;
  const hasError = inputCount > maxLength;

  useEffect(() => {
    if (hasError) {
      setError(name, { type: "maxLength", message: errorMessage });
    } else {
      clearErrors(name);
    }
  }, [hasError, name, clearErrors, setError, errorMessage]);

  return (
    <div className={classNames("flex flex-col gap-y-1", className)}>
      <div className="flex flex-row items-center justify-between">
        <ItemLabel label={label} />
        <Typography.LabelXs
          color={hasError ? "text-v2-danger" : "text-default"}
        >
          {`${inputCount} / ${maxLength}`}
        </Typography.LabelXs>
      </div>
      {children}
    </div>
  );
};
